export class ProductRelationFilterModel {
    public searchTerm: string;
    public selectedCategoryTypeId: number;
}